import Papa from 'papaparse'
import { PropertyData } from '../models/data/PropertyData'

export const exportToCSV = async (data: PropertyData[], filename: string) => {
  const dataStr = Papa.unparse(data)
  const dataurl = `data:text/csv;base64,${btoa(dataStr)}`
  const response = await fetch(dataurl)
  const blob = await response.blob()
  const downloadUrl = window.URL.createObjectURL(blob)
  const tempLink = document.createElement('a')
  tempLink.href = downloadUrl
  tempLink.setAttribute('download', filename)
  tempLink.click()
}
